import { useHistory } from "react-router-dom";
import { useState } from 'react';
import Masthead, {
  MastheadTitle,
  MastheadLink,
} from "@amzn/meridian/masthead"

import Heading from "@amzn/meridian/heading"

export default function InnerHeader() {

  // selected header item
  const [selected, setSelected] = useState("")

  // Update history when link is clicked
  const history = useHistory();
  function goToEngineeringDecisionTree() {
    setSelected("one");
    history.push('/engineeringDecisionTree');
  }
  function goToCustomerDecisionTree() {
    setSelected("two");
    history.push('/customerDecisionTree');
  }
  function goToSOP() {
    setSelected("three");
    history.push('/sop');
  }
    function goToGSCTeam() {
    setSelected("four");
    history.push('/gscTeam');
  }
  
  return (
    <Masthead>
      <MastheadTitle>
        <Heading level={2}>
          SCOT Site Launch Tool         
        </Heading>
      </MastheadTitle>
      {/* <MastheadLink selected={selected === "one"} onClick={goToEngineeringDecisionTree}>
        Engineering Decision Tree
      </MastheadLink> */}
      <MastheadLink selected={selected === "two"} onClick={goToCustomerDecisionTree}>
        Check Site Launch Readiness
      </MastheadLink>
      <MastheadLink selected={selected === "three"} onClick={goToSOP}>
        Forecast Launch SOP
      </MastheadLink>
      <MastheadLink selected={selected === "four"} onClick={goToGSCTeam}>
        GSC Team
      </MastheadLink>
    </Masthead>
  );
}